<template>
  <div v-if="!spot.archivedOn && authenticated && spot.userData?.spotAuthor && spotWillBeArchivedSoon"
       class="flex-row items-center space-y-2 my-1 p-3 bg-theme-secondary">
    <h2 class="text-white text-center">{{ $t('spotdetail.spot_will_be_archived_title') }}</h2>
    <i18n-t
        keypath="spotdetail.spot_will_be_archived_text"
        tag="p"
        class="text-white text-center"
        scope="global"
    >
      <template v-slot:date
      >{{ $d(spot.archiveOn) }}
      </template
      >
    </i18n-t>
    <div class="flex items-center">
      <ButtonSubmit
          :loading="loading"
          :error="error"
          @click="delayArchiving"
          color="whiteOnBlue"
          :title="$t('spotdetail.spot_will_be_archived_button_text')"
          class="grow"
      ></ButtonSubmit>
    </div>
  </div>
  <div v-else-if="spot.archiveOn && !spot.archivedOn" class="mt-1 p-2 text-white bg-theme-secondary">
    <i18n-t
        keypath="spotdetail.spot_will_be_archived_text"
        tag="p"
        class="text-white"
        scope="global"
    >
      <template v-slot:date
      >{{ $d(spot.archiveOn) }}
      </template
      >
    </i18n-t>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  spot: SpotDetail;
}>();

const loading = ref(false);
const error = ref<boolean>(false);
const authenticated = useAuth().authenticated;


const spotWillBeArchivedSoon = computed(() => {
  return props.spot.archiveOn && Date.now() + 7 * 24 * 60 * 60 * 1000 > props.spot.archiveOn;
});

function delayArchiving() {
  loading.value = true;
  error.value = false;
  useApiAuth().post<number>(`spots/${props.spot.id}/delayarchive`).then((result: number) => {
    props.spot.archiveOn = result;
  }).catch(() => {
    error.value = true;
  }).finally(() => {
    loading.value = false;
  })
}

</script>
